import React, { useEffect } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import { Common, SettingsIcons } from "../../assets/images";
// Redux imports
import { Visa } from "../../interfaces/employee";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import {
  setFilterVisaTotalPages,
  setVisaListLoading,
} from "../../store/slices/campsSlice";
// API imports
import { useGetFilterVisaListMutation } from "../../services/Camps";
import SelectSearch from "react-select-search";

interface Props {
  show?: boolean;
  setShow?: any;
  setVisaList?: any;
  filterSearch: boolean;
  setFilterSearch: any;
  visaList: Visa[];
  query: string;
  filterInput: FormProps;
  setFilterInput: any;
}

export interface FormProps {
  recruiterId: string;
}

const VisaFilterModal = ({
  show,
  setShow,
  visaList,
  setVisaList,
  setFilterSearch,
  query,
  filterInput,
  setFilterInput,
  filterSearch,
}: Props) => {
  const dispatch = useAppDispatch();
  const state = useAppSelector((state) => state.camps);
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);
  const [getFilterVisaList] = useGetFilterVisaListMutation();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    dispatch(setVisaListLoading(true));
    setFilterSearch(true);
    setShow(false);
    // Filter employees based on the form values
    try {
      const data = {
        userID: userID || "",
        accessToken: accessToken || "",
        permission: profileData?.permissions.showLegal || false,
        payload: {
          page: state.filterVisaPageNo,
          limit: state.filterVisaPageSize,
          establishmentName: filterInput.recruiterId,
        },
      };
      const response = await getFilterVisaList(data).unwrap();
      if (response) {
        setVisaList(response.data.visa[0].data);
        dispatch(
          setFilterVisaTotalPages(response.data.visa[0].metadata[0].total),
        );
      }
    } catch (e: any) {
    } finally {
      dispatch(setVisaListLoading(false));
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      dispatch(setVisaListLoading(true));
      // Filter employees based on the form values
      try {
        const data = {
          userID: userID || "",
          accessToken: accessToken || "",
          permission: profileData?.permissions.showLegal || false,
          payload: {
            page: state.filterVisaPageNo,
            limit: state.filterVisaPageSize,
            visaNumber: query,
            establishmentName: filterInput.recruiterId,
          },
        };
        const response = await getFilterVisaList(data).unwrap();
        if (response) {
          setVisaList(response.data.visa[0].data);
          dispatch(
            setFilterVisaTotalPages(response.data.visa[0].metadata[0].total),
          );
        }
      } catch (e: any) {
      } finally {
        dispatch(setVisaListLoading(false));
      }
    };
    if (filterSearch) {
      fetchData();
    }
  }, [state.filterVisaPageNo, state.filterVisaPageSize, query]);

  const handleReset = () => {
    setVisaList(visaList);
    setFilterInput({
      recruiterId: "",
    });
  };

  const sponsorIds = useAppSelector((state) => state.sponsor.sponsorIds);

  const recruitOptions = sponsorIds.map((employee) => ({
    name: employee.companyId + " - " + employee.companyName, // Use the actual property name for the project name
    value: employee.companyName,
  }));

  return (
    <>
      <Modal
        show={show}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        size="lg"
        className="general-modal"
      >
        <Modal.Body className="text-center px-5">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h4 className="heading">Filter Visa List</h4>
            <button className="btn p-0 border-0" onClick={() => setShow(false)}>
              <img src={SettingsIcons.CrossIcon} alt="edit-icon" />
            </button>
          </div>
          <div className="change-password">
            <Form onSubmit={handleSubmit} className="text-end">
              <Row>
                <Col sm="12">
                  <Form.Group
                    className="mb-3 text-start"
                    controlId="formBasicEmail"
                  >
                    <h4
                      className="sub-heading normal-font-weight textBlack"
                      style={{ fontSize: "18px" }}
                    >
                      Establishment Name
                    </h4>
                    <Form.Group className="position-relative input-design d-flex align-items-center">
                      <SelectSearch
                        name="recruiterId"
                        options={recruitOptions}
                        value={filterInput.recruiterId}
                        onChange={(value: any) => {
                          setFilterInput({
                            ...filterInput,
                            recruiterId: value,
                          });
                        }}
                        search={true}
                        placeholder="Select establishment name"
                      />
                      <img src={Common.ArrowDown} alt="message" />
                    </Form.Group>
                  </Form.Group>
                </Col>
              </Row>
              <div className="mt-4">
                <button
                  className="btn primary-button text-center w-25 me-2"
                  onClick={handleReset}
                  type="button"
                >
                  Reset
                </button>
                <button
                  className="btn primary-button text-center w-25"
                  type="submit"
                >
                  Filter
                </button>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default VisaFilterModal;
